import { API_ROUTES } from "definitions/constants/routeConstants";
import { generatePath as caminoGeneratePath } from "helpers/url/pages/v1";

// Resources
export function apiPrebuiltEmailTemplateById(prebuiltEmailTemplateId: string) {
  return caminoGeneratePath({ path: API_ROUTES.prebuilt.emailTemplates.show, params: { id: prebuiltEmailTemplateId || "" } });
}

export function apiPrebuiltMeetingTemplateById(prebuiltMeetingTemplateId: string) {
  return caminoGeneratePath({ path: API_ROUTES.prebuilt.meetingTemplates.show, params: { id: prebuiltMeetingTemplateId || "" } });
}

export function apiPrebuiltMessageTemplateById(prebuiltMessageTemplateId: string) {
  return caminoGeneratePath({ path: API_ROUTES.prebuilt.messageTemplates.show, params: { id: prebuiltMessageTemplateId || "" } });
}

export function apiPrebuiltTaskTemplateById(prebuiltTaskTemplateId: string) {
  return caminoGeneratePath({ path: API_ROUTES.prebuilt.taskTemplates.show, params: { id: prebuiltTaskTemplateId || "" } });
}
